import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebook, faYoutube } from "@fortawesome/free-brands-svg-icons";
import { useTranslation } from "react-i18next";
import "./Footer.css";
import { useLocation, useMatch } from "react-router-dom";

const Footer: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();
const matchWithEntreprise = useMatch("/inscription/:code/:entrepriseId");
const matchWithoutEntreprise = useMatch("/inscription/:code");
const isInscriptionPage = Boolean(matchWithEntreprise || matchWithoutEntreprise);
 
  return isInscriptionPage ? (
    <div className="footer-bottom">
      <div className="container">
        <div className="footer-copyright">
          &copy; {new Date().getFullYear()} YATA MEDICAL.{" "}
          {t("footer.copyright")}
        </div>
      </div>
    </div>
  ) : (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section contact-section">
            <h3>{t("footer.contact")}</h3>
            <ul className="contact-info">
              <li>
                <div className="contact-item">
                  <FontAwesomeIcon
                    icon={faMapMarkerAlt}
                    className="contact-icon"
                  />
                  <div className="contact-text">
                    <strong>{t("footer.address")}</strong>
                    <span>{t("footer.addressDetails")}</span>
                  </div>
                </div>
              </li>
              <li>
                <div className="contact-item">
                  <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                  <div className="contact-text">
                    <strong>{t("footer.phone")}</strong>
                    <span>+222 24 40 00 01</span>
                  </div>
                </div>
              </li>
              <li>
                <div className="contact-item">
                  <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                  <div className="contact-text">
                    <strong>{t("footer.email")}</strong>
                    <span>info@yatamedical.com</span>
                  </div>
                </div>
              </li>
            </ul>
            <div className="social-linksf">
              <a
                href="https://www.facebook.com/profile.php?id=100064143335364"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </a>
              <a
                href="https://www.youtube.com/@yatamedical7487"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </a>
            </div>
          </div>

          <div className="footer-section map-section">
            <h3 className="gr-title-2">{t("footer.ourLocation")}</h3>
            <div className="map-container">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3827.7276832456385!2d-15.998277424514599!3d18.097333982566387!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTjCsDA1JzUwLjQiTiAxNcKwNTknNDUuOCJX!5e0!3m2!1sen!2s!4v1639601234567!5m2!1sen!2s"
                width="100%"
                height="150"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="YATA MEDICAL Location"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <div className="footer-copyright">
            &copy; {new Date().getFullYear()} YATA MEDICAL.{" "}
            {t("footer.copyright")}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
